import React from "react";
import { Modal, Divider, Form, Row, Col, Button, Checkbox } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { Input } from "antd";
import { useDispatch } from "react-redux";

const { TextArea } = Input;

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
  },
}));

const DeliveryModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [form] = Form.useForm();
  const handleSubmit = (values) => {
    dispatch({
      type: "SET_ADDRESS",
      payload: {
        billingAddress: values.billingAddress,
        shippingAddress: values.shippingAddress,
      },
    });
    setOpen(false);
    form.resetFields();
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCheckBox = (e) => {
    const value = e.target.checked;
    const billingAddress = form.getFieldValue("billingAddress");
    if (value) {
      form.setFieldsValue({
        shippingAddress: billingAddress,
      });
    } else {
      form.setFieldsValue({
        shippingAddress: "",
      });
    }
  };
  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={false}
      centered
      className={classes.modalStyle}
      width={500}
      getContainer={false}
    >
      <h3
        style={{
          color: "#EF4667",
        }}
      >
        Delivery Address
      </h3>
      <Divider className={classes.dividerStyle} />
      <Form
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        form={form}
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Billing Address" name="billingAddress">
              <TextArea rows={4} placeholder="Enter Billing Address" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Shipping Address" name="shippingAddress">
              <TextArea rows={4} placeholder="Enter Shipping Address" />
            </Form.Item>
          </Col>
          <Col
            style={{
              marginLeft: "auto",
            }}
          >
            <Checkbox onChange={handleCheckBox}>
              Same as Billing Address
            </Checkbox>
          </Col>
        </Row>
        <Divider className={classes.dividerStyle} />
        <div
          style={{
            textAlign: "right",
            marginTop: "8px",
          }}
        >
          <Button size="large" onClick={handleClose} type="link">
            Cancel
          </Button>
          <Button
            size="large"
            htmlType="submit"
            style={{
              marginLeft: "16px",
            }}
            className={classes.ButtonStyle}
          >
            Confirm
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default DeliveryModal;
